/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CreateFamilyMemberTemporaryPinCodePayload } from 'api/actions/create-family-member-temporary-pin-code/create-family-member-temporary-pin-code-payload';
import { CreateFamilyMemberTemporaryPinCodePathParameters } from 'api/actions/create-family-member-temporary-pin-code/create-family-member-temporary-pin-code-path-parameters';
import { CreateFamilyMemberTemporaryPinCodeResponse } from 'api/actions/create-family-member-temporary-pin-code/create-family-member-temporary-pin-code-response';

type CreateFamilyMemberTemporaryPinCodeQueryParameters = Record<string, any>;

/**
 * The path of the CreateFamilyMemberTemporaryPinCode action.
 */
export const createFamilyMemberTemporaryPinCodeActionPath = new SweetPath<
  keyof CreateFamilyMemberTemporaryPinCodePathParameters
>('/user/family/members/{userId}/pin/temporary', { path: '{param}' });

/**
 * Creates a contextualized CreateFamilyMemberTemporaryPinCode actions.
 */
export default function createCreateFamilyMemberTemporaryPinCodeAction(axios: AxiosInstance) {
  return function createFamilyMemberTemporaryPinCodeAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: CreateFamilyMemberTemporaryPinCodePathParameters;
    query?: CreateFamilyMemberTemporaryPinCodeQueryParameters;
    payload: CreateFamilyMemberTemporaryPinCodePayload;
  }) {
    const path = createFamilyMemberTemporaryPinCodeActionPath.insert(parameters);

    return axios.post<
      CreateFamilyMemberTemporaryPinCodeResponse,
      CreateFamilyMemberTemporaryPinCodeResponse,
      CreateFamilyMemberTemporaryPinCodePayload
    >(path, payload);
  };
}
